import axios from 'axios';

export default class HealthCheckService {
  public static checkServerHealth(): Promise<any> {
    return axios.get('/api/v1/actuator/health');
  }
}
